import i18n from "@/plugins/i18n";
import { filterCapitalize } from "@/filters/capitalize";
import { RuleFunctionExtended } from "@/models/components/inputs/RuleFunction";

const maxLengthValidator: RuleFunctionExtended = (value: unknown | string | null, param: number): boolean | string => {
  if (value == null) {
    return true;
  }
  if (typeof value === "string" && value.length <= param) {
    return true;
  }
  return filterCapitalize(
    i18n
      .t("validation.outOfRange", {
        max: param,
      })
      .toString()
  );
};

export { maxLengthValidator };
export default maxLengthValidator;
